import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MatPaginator, MatSort, MAT_DIALOG_DATA } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'm-dialog-result-prorroga',
  templateUrl: './dialog-result-prorroga.component.html',
  styleUrls: ['./dialog-result-prorroga.component.scss']
})
export class DialogResultProrrogaComponent implements OnInit {

  viewLoading: boolean = false;
  listData: MatTableDataSource<any> = new MatTableDataSource([]);

  displayedColumns: string[] = ['DNI','FechaInicioContrato','FinContrato', 'NombreApellidos', 'Respuesta'];

  @ViewChild('ASIGMatPaginator', {read: MatPaginator}) ASIGMatPaginator: MatPaginator;
  @ViewChild('ASIGMatSort') ASIGMatSort: MatSort;
  load_data: boolean = true;
  no_data: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogResultProrrogaComponent>,
    private _formBuilder_lote: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.listData = new MatTableDataSource(this.data.datos);
    this.no_data = true;
    this.listData.sort = this.ASIGMatSort;
    this.listData.paginator = this.ASIGMatPaginator;
  }

  onNoClick(): void {
		this.dialogRef.close();
  }


}

